<template>
  <el-dialog width="1200px" :modal-append-to-body="false" style="with:800px" :visible.sync="visible" :title="!dataForm.id ? '新增税源地' : '修改税源地'" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" :label-width="$i18n.locale === 'en-US' ? '140px' : '140px'">
		<el-row>

			<el-col :span="12">
				<el-form-item label="法人身份证正反面：">
					<el-row>
						<el-col :span="12">
							<el-form-item prop="legalPersonIdcardFace">
								<el-upload
										ref="upload"
										:action="url"
										class="avatar-uploader"
										:multiple="multiple"
										:before-upload="beforeUploadHandle"
										:on-success="beforesuccessHandle"
										:auto-upload="true"
										:show-file-list="false"
										style="width: 130px;height: 115px;"
										:disabled="true"
								>
									<img style="width: 130px;height: 115px;" @click="yulan(dataForm.legalPersonIdcardFace)" v-if="dataForm.legalPersonIdcardFace" :src="dataForm.legalPersonIdcardFace" class="avatar">
									<i v-else style="width: 130px;height: 115px;"  :style="{backgroundImage:'url('+require('../../../assets/img/cardFront.png')+')',backgroundSize:'100% 100%',backgroundRepeat:'no-repeat',color:'#315DD1'}" class="el-icon-circle-plus avatar-uploader-icon"></i>

								</el-upload>

							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item prop="idcardFacePath">
								<el-upload
										ref="upload"
										:action="url"
										class="avatar-uploader"
										:multiple="multiple"
										:before-upload="beforeUploadHandle"
										:on-success="backsuccessHandle"
										:auto-upload="true"
										:show-file-list="false"
										style="width: 130px;height: 115px;"
										:disabled="true"
								>
									<img @click="yulan(dataForm.legalPersonIdcardBack)" style="width: 130px;height: 115px;" v-if="dataForm.legalPersonIdcardBack" :src="dataForm.legalPersonIdcardBack" class="avatar">
									<i v-else style="width: 130px;height: 115px;" :style="{backgroundImage:'url('+require('../../../assets/img/cardBack.png')+')',backgroundSize:'100% 100%',backgroundRepeat:'no-repeat',color:'#315DD1'}" class="el-icon-circle-plus avatar-uploader-icon"></i>
								</el-upload>

							</el-form-item>
						</el-col>
					</el-row>
				</el-form-item>
			</el-col>
			<el-col :span="12">
				<el-form-item label="办税人员身份证正反面：">
					<el-row>
						<el-col :span="12">
							<el-form-item prop="legalPersonIdcardFace">
								<el-upload
										ref="upload"
										:action="url"
										class="avatar-uploader"
										:multiple="multiple"
										:before-upload="beforeUploadHandle"
										:on-success="legalbeforesuccessHandle"
										:auto-upload="true"
										:show-file-list="false"
										style="width: 130px;height: 115px;"
										:disabled="true"
								>
									<img @click="yulan(dataForm.taxOfficerIdcardFace)" style="width: 130px;height: 115px;" v-if="dataForm.taxOfficerIdcardFace" :src="dataForm.taxOfficerIdcardFace" class="avatar">
									<i v-else style="width: 130px;height: 115px;" :style="{backgroundImage:'url('+require('../../../assets/img/cardFront.png')+')',backgroundSize:'100% 100%',backgroundRepeat:'no-repeat',color:'#315DD1'}" class="el-icon-circle-plus avatar-uploader-icon"></i>
								</el-upload>

							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item prop="idcardFacePath">
								<el-upload
										ref="upload"
										:action="url"
										class="avatar-uploader"
										:multiple="multiple"
										:before-upload="beforeUploadHandle"
										:on-success="legalbacksuccessHandle"
										:auto-upload="true"
										:show-file-list="false"
										style="width: 130px;height: 115px;" :disabled="true"
								>
									<img @click="yulan(dataForm.taxOfficerIdcardBack)" style="width: 130px;height: 115px;" v-if="dataForm.taxOfficerIdcardBack" :src="dataForm.taxOfficerIdcardBack" class="avatar">
									<i v-else style="width: 130px;height: 115px;" :style="{backgroundImage:'url('+require('../../../assets/img/cardBack.png')+')',backgroundSize:'100% 100%',backgroundRepeat:'no-repeat',color:'#315DD1'}" class="el-icon-circle-plus avatar-uploader-icon"></i>
								</el-upload>

							</el-form-item>
						</el-col>
					</el-row>
				</el-form-item>
			</el-col>
		</el-row>
		<el-row>
			<el-col :span="12">
				<el-form-item label="企业营业执照照片：" prop="businessLicense">
					<el-upload
							ref="upload"
							:action="url"
							class="avatar-uploader"
							:multiple="multiple"
							:before-upload="beforeUploadHandle"
							:on-success="beforesuccessbusinessLicense"
							:auto-upload="true"
							:show-file-list="false"
							style="width: 130px;height: 115px;" :disabled="true"
					>
						<img @click="yulan(dataForm.businessLicense)" style="width: 130px;height: 115px;" v-if="dataForm.businessLicense" :src="dataForm.businessLicense" class="avatar">
						<i v-else style="width: 130px;height: 115px;" :style="{backgroundImage:'url('+require('../../../assets/img/yingye.png')+')',backgroundSize:'100% 100%',backgroundRepeat:'no-repeat',color:'#315DD1'}" class="el-icon-circle-plus avatar-uploader-icon"></i>
					</el-upload>

				</el-form-item>
			</el-col>
			<el-col :span="12">
				<el-form-item label="企业资质：" >
					<el-row>
						<el-col v-if="certificates.length > 0" :span="10">
							<img v-for="(item,index) in certificates" style="width: 130px;height: 115px;" v-if="certificates.length > 0" :src="item" class="avatar">
						</el-col>
						<el-col v-else :span="10">
							<img style="width: 130px;height: 115px;" :src="require('../../../assets/img/yingye.png')" class="avatar">
						</el-col>
						<el-col :span="4" v-if="certificates.length > 0" >
							<img :src="require('../../../assets/img/more.png')" @click="showmsg()" style="width: 30px;height: 30px;"/>
						</el-col>
					</el-row>
				</el-form-item>
			</el-col>
		</el-row>
		<el-row>
			<el-col :span="12">
				<el-form-item label="企业简介：" prop="intro">
					<el-input v-model="dataForm.intro" :disabled="true"  maxlength="200" show-word-limit type="textarea" placeholder="企业简介" style="border: none"></el-input>
				</el-form-item>
			</el-col>
			<el-col :span="12">
				<el-form-item label="经营范围：" prop="businessScope">
				    <el-input v-model="dataForm.businessScope" :disabled="true"  maxlength="200" show-word-limit type="textarea" placeholder="经营范围" style="border: none"></el-input>
				</el-form-item>
			</el-col>
		</el-row>
		<el-row>
			<el-col :span="12">
				<el-form-item label="税源地" prop="bodyName">
				  <el-input v-model="dataForm.bodyName" :disabled="true" placeholder="税源地"></el-input>
				</el-form-item>
			</el-col>
			<el-col :span="12">
				<el-form-item label="税源地简称" prop="abbreviation">
				  <el-input v-model="dataForm.abbreviation" :disabled="true" placeholder="税源地简称"></el-input>
				</el-form-item>
			</el-col>
			<el-col :span="12">
				<el-form-item label="社会信用代码" prop="taxCode">
				    <el-input v-model="dataForm.taxCode" :disabled="true" placeholder="社会信用代码"></el-input>
				</el-form-item>
			</el-col>
			<el-col :span="12">
				<el-form-item label="开户行" prop="bankName">
				    <el-input v-model="dataForm.bankName" :disabled="true" placeholder="开户行"></el-input>
				</el-form-item>
			</el-col>
			<el-col :span="12">
				<el-form-item label="开户账号" prop="bankAccount">
				    <el-input v-model="dataForm.bankAccount" :disabled="true" placeholder="开户账号"></el-input>
				</el-form-item>
			</el-col>
			<el-col :span="12">
				<el-form-item label="注册地址" prop="address">
				    <el-input v-model="dataForm.address" :disabled="true" placeholder="注册地址"></el-input>
				</el-form-item>
			</el-col>
			<el-col :span="12">
				<el-form-item label="联系电话" prop="phone">
				    <el-input v-model="dataForm.phone" :disabled="true" placeholder="联系电话"></el-input>
				</el-form-item>
			</el-col>
			<el-col :span="12">
				<el-form-item label="法人姓名：" prop="legalPersonName">
				    <el-input v-model="dataForm.legalPersonName" :disabled="true" placeholder="法人姓名"></el-input>
				</el-form-item>
			</el-col>
			<el-col :span="12">
				<el-form-item label="办税人员姓名：" >
				    <el-input v-model="dataForm.taxOfficerName" :disabled="true" placeholder="办税人员姓名"></el-input>
				</el-form-item>
			</el-col>
			<el-col :span="12">
				<el-form-item label="法人身份证号：" prop="legalPersonIdcard">
				    <el-input v-model="dataForm.legalPersonIdcard" :disabled="true" placeholder="法人身份证号"></el-input>
				</el-form-item>
			</el-col>
			<el-col :span="12">
				<el-form-item label="办税人员身份证号：" >
				    <el-input v-model="dataForm.taxOfficerIdcard" :disabled="true" placeholder="办税人员身份证"></el-input>
				</el-form-item>
			</el-col>
			<el-col :span="12">
				<el-form-item label="法人手机号：" prop="legalPersonPhone">
				    <el-input v-model="dataForm.legalPersonPhone" :disabled="true" placeholder="法人手机号"></el-input>
				</el-form-item>
			</el-col>
			<el-col :span="12">
				<el-form-item label="办税人员手机号：" >
				    <el-input v-model="dataForm.taxOfficerPhone" :disabled="true" placeholder="办税人员手机号"></el-input>
				</el-form-item>
			</el-col>
		</el-row>
		<el-row>
        	<el-col :span="12">
        		<el-form-item prop="companyScale" label="企业规模">
        		    <ren-radio-group v-model="dataForm.companyScale" :disabled="true" dict-type="companyScale"></ren-radio-group>
        		</el-form-item>
        	</el-col>
        	<el-col :span="12">
        		<el-form-item prop="isEnable" label="状态">
        		    <ren-radio-group v-model="dataForm.isEnable" :disabled="true" dict-type="isEnable"></ren-radio-group>
        		</el-form-item>
        	</el-col>
        </el-row>

      </el-form>
    <template slot="footer">
      <el-button type="primary" @click="visible = false">{{ $t('confirm') }}</el-button>
    </template>

	<el-dialog :modal-append-to-body="true" :append-to-body="true" :modal="false" title="企业资质" width="700px" custom-class="dialogBg" :show-close="false" top="264px" center :visible.sync="dialogVisible">

		<el-row>
			<el-col v-for="(item,index) in certificates" :key="index" :offset="1" v-if="certificates.length > 0" :span="8">
				<img style="width: 130px;height: 115px;margin:10px;" @click="yulan(item)" :src="item" class="avatar">
			</el-col>
		</el-row>
		<template slot="footer">
		  <el-button @click="dialogVisible = false">{{ $t('cancel') }}</el-button>
		</template>
	</el-dialog>
  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
import Cookies from 'js-cookie'
// import ossUploadImg from '../oss/oss-upload-img'
export default {
  components: {
    // ossUploadImg
  },
  data () {
    return {
      visible: false,
	  multiple:true,
	  loadingbut: false,
	  url: `${window.SITE_CONFIG['apiURL']}/oss/file/upload2?access_token=${Cookies.get('access_token')}`,
	  certificates: [],
	  dialogVisible: false,
      dataForm: {
        id: '',
        intro: '',
        businessScope: '',
        legalPersonName: '',
        legalPersonPhone: '',
        legalPersonIdcard: '',
        taxOfficerName: '',
        taxOfficerPhone: '',
        taxOfficerIdcard: '',
        bodyName: '',
		abbreviation:'',
        bodyCode: '',
        taxCode: '',
        bankName: '',
        bankAccount: '',
        address: '',
        phone: '',
        companyScale: '',
        isEnable: 1,
        legalPersonIdcardBack: '',
        legalPersonIdcardFace: '',
        taxOfficerIdcardBack: '',
        taxOfficerIdcardFace: '',
        certificates: '',
        businessLicense: ''
      }
    }
  },
  computed: {
    dataRule () {
      return {
        isEnable: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        intro: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        businessScope: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        legalPersonName: [
          { required: false, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        legalPersonPhone: [
          { required: false, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        legalPersonIdcard: [
          { required: false, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        taxOfficerName: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        taxOfficerPhone: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        taxOfficerIdcard: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        bodyName: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
		abbreviation:[
			{ required: true, message: this.$t('validate.required'), trigger: 'blur' }
		],
        bodyCode: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        taxCode: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        bankName: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        bankAccount: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        address: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        contacts: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        phone: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        companyScale: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        legalPersonIdcardBack: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        legalPersonIdcardFace: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        taxOfficerIdcardBack: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        taxOfficerIdcardFace: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        certificates: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        businessLicense: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
	  // 上传之前
	  beforeUploadHandle (file) {
	      if (file.type !== 'image/jpg' && file.type !== 'image/jpeg' && file.type !== 'image/png' && file.type !== 'image/gif') {
	        this.$message.error(this.$t('upload.tip', { 'format': 'jpg、png、gif,pdf' }))
	        return false
	      }
		   if (file.size / 1024 / 1024 > 30) { this.$message.error('文件太大，只能上传30MB以内的文件'); return false }
	  },
	  showmsg () {
      this.dialogVisible = true
	  },
	  // 上传成功
	  beforesuccessHandle (data, file) {
	      this.dataForm.legalPersonIdcardFace = data.data.url
	  },
	  backsuccessHandle (data, file) {
	      this.dataForm.legalPersonIdcardBack = data.data.url
	  },
	  legalbeforesuccessHandle (data, file) {
	      this.dataForm.taxOfficerIdcardFace = data.data.url
	  },
	  legalbacksuccessHandle (data, file) {
	      this.dataForm.taxOfficerIdcardBack = data.data.url
	  },
	  beforesuccessbusinessLicense (data, file) {
	      this.dataForm.businessLicense = data.data.url
	  },
	  backsuccesscertificates (data, file) {
	      this.dataForm.certificates = data.data.url
	  },
    yulan (url) {
      window.open(url, url)
    },
    init () {
      this.visible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].resetFields()
        if (this.dataForm.id) {
          this.getInfo()
        }
      })
    },
    // 获取信息
    getInfo () {
      this.$http.get(`/sys/plat/body/${this.dataForm.id}`).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.dataForm = {
          ...this.dataForm,
          ...res.data
        }

        this.certificates = this.dataForm.certificates ? this.dataForm.certificates.split(','):"";
      }).catch(() => {})
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        this.loadingbut = true
        this.$http[!this.dataForm.id ? 'post' : 'put']('/sys/plat/body/', this.dataForm).then(({ data: res }) => {
          this.loadingbut = false
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.visible = false
              this.$emit('refreshDataList')
            }
          })
        }).catch(() => {})
      })
    }, 1000, { 'leading': true, 'trailing': false })
  }
}
</script>
